import { Pipe, PipeTransform } from '@angular/core';
import { Transaction } from '../../schemas/transaction';

@Pipe({
  name: 'transactionStatusFilter',
  standalone: true,
})
export class TransactionStatusFilterPipe implements PipeTransform {
  transform(transactions: Transaction[], searchText: string): Transaction[] {
    if (!transactions) return [];
    if (searchText == 'ALL' || !searchText) return transactions;
    // searchText = searchText.toLowerCase();
    // console.log('searchText', searchText);

    return transactions.filter((searchItem) => {
      return searchItem.status == searchText;
    });
  }
}
